<template>
  <div>
    <h2>Výběr dat</h2>
    <label class="container">
      Zotavovací akce
      <input
        type="checkbox"
        v-model="showZotavovaciInternal"
        @change="toggleShowZotavovaci"
      />
      <span class="checkmark"></span>
    </label>
    <label class="container">
      Jiné podobné akce
      <input
        type="checkbox"
        v-model="showJineInternal"
        @change="toggleShowJine"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "selection",
  mounted() {
    this.$emit("caption", "Výběr dat");
  },
  props: {
    showZotavovaci: Boolean,
    showJine: Boolean
  },
  data() {
    return {
      showZotavovaciInternal: this.showZotavovaci,
      showJineInternal: this.showJine
    };
  },
  methods: {
    toggleShowZotavovaci() {
      this.$emit("toggleShowZotavovaci", this.showZotavovaciInternal);
    },
    toggleShowJine() {
      this.$emit("toggleShowJine", this.showJineInternal);
    }
  }
};
</script>

<style scoped>
button {
  background-color: #005fa2;
  border: none;
  color: white;
  padding: 10px 29px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-top: 15px;
  margin-left: 4px;
}

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
}

.container:hover input ~ .checkmark {
  background-color: #ccc;
}

.container input:checked ~ .checkmark {
  background-color: #006622;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked ~ .checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 8px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
